import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useSuperDuper } from '../context/SuperDuperContext';

const AppSnackbar = () => {
  const { snackbar, handleCloseSnackbar } = useSuperDuper();

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={handleCloseSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default AppSnackbar;
